module.exports = __webpack_public_path__ + "img/azure-excursion.8d4def60.webp";